import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreCategory } from '@types';

const useGetCategory = () => {
    const data = useStaticQuery(graphql`
        query AllCategory {
            allPatstoreCategory {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    category_id
    image
    description
    type
    
                    }
                }
            }
        }
    
        `);


    const allCategory: PatstoreCategory[] =
        data.allPatstoreCategory.edges.map(
            (edge: { node: PatstoreCategory }) => edge.node
        ) || [];

    const findCategory: (id: string) => PatstoreCategory | undefined = (id: string) => {
        const result = allCategory.find((item: PatstoreCategory) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findCategory,
        categorys: allCategory,
    };
}; 

export default useGetCategory;
